module.exports = __webpack_public_path__ + "img/91.8.TSS.1aa707fc.png";